// Shared helpers for the landing page

export const WHATSAPP = process.env.REACT_APP_WHATSAPP_NUMBER || "+919876543210";
export const VIDEO_URL = process.env.REACT_APP_WALKTHROUGH_VIDEO_URL || "";

// Convert YouTube / Loom URL → embeddable src
export function toEmbedSrc(url) {
  if (!url) return "";
  const yt = url.match(/(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/|v\/))([\w-]{11})/);
  if (yt) return `https://www.youtube.com/embed/${yt[1]}?rel=0&modestbranding=1`;
  const loom = url.match(/loom\.com\/share\/([\w-]+)/);
  if (loom) return `https://www.loom.com/embed/${loom[1]}`;
  return url;
}

export function waHref(text) {
  const num = WHATSAPP.replace(/[^\d]/g, "");
  return `https://wa.me/${num}?text=${encodeURIComponent(text)}`;
}
